import { Component, ViewEncapsulation, ViewChild, Output, EventEmitter, Input, AfterViewInit, ElementRef } from '@angular/core';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { throttleTime } from 'rxjs/operators';
import { asyncScheduler } from 'rxjs';
import { AutoSub, AutoSubOnDestroy } from '../../providers/auto-sub';

export interface MoveEvent { id?: string, x?: number, y?: number, xn: number, yn: number };

@AutoSubOnDestroy()
@Component({
    selector: 'drag-item',
    templateUrl: './drag-item.component.html',
    styleUrls: ['./drag-item.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DragItemComponent implements AfterViewInit {

    @ViewChild(CdkDrag, { static: true }) dragItem: CdkDrag;


    @Input() id: string = "";
    @Input() boundarySelector: string;
    @Input() set container(div: HTMLElement) {
        this.containerDiv = div;
        this.updateContainerSize(div);
    }

    @Output('positionChange') positionChange = new EventEmitter<MoveEvent>();
    @Input() set position(pos: MoveEvent) {
        this.updateContainerSize(this.containerDiv);
        // Update the position
        pos.x = Math.round(pos.xn * (this.containerWidth - 50));
        pos.y = Math.round(pos.yn * (this.containerHeight - 50));
        this.dragItem.element.nativeElement.style.transform = `translate3d(${pos.x}px, ${pos.y}px, 0px)`;

        // Notify all listners about the position change
        pos.id = this.id;
        this.positionChange.next(pos);
    }


    private containerDiv: HTMLElement = null;
    private containerWidth: number = 100;
    private containerHeight: number = 100;

    constructor() {
    }

    private updateContainerSize(container: HTMLElement) {
        if(!container) return;
        this.containerWidth = container.clientWidth;
        this.containerHeight = container.clientHeight;
    }

    private getTranslate(ele) {
        var style = window.getComputedStyle(ele);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);
        return { x: matrix.m41 + 1, y: matrix.m42 + 1 };
    }

    ngAfterViewInit() {
        this.updateContainerSize(this.containerDiv);
        let width = this.containerWidth;
        let height = this.containerHeight;

        // Subscribe to drag events
        AutoSub(this).reg['dragSub'] = this.dragItem.moved.pipe(throttleTime(300, asyncScheduler, { leading: true, trailing: true })).subscribe((ev) => {
            let ele = ev.source.element.nativeElement;
            let coords = this.getTranslate(ele);
            let normalizedX = width ? coords.x / (width - ele.clientWidth + 2) : 0;
            let normalizedY = height ? coords.y / (height - ele.clientHeight + 2) : 0;
            this.positionChange.next({ id: this.id, x: coords.x, y: coords.y, xn: Math.floor(normalizedX * 1000) / 1000, yn: Math.floor(normalizedY * 1000) / 1000 });
        });
    }
}
